import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

export const GlobalStyles = createGlobalStyle<{ theme: any }>`
  ${reset}

  .sleepunique-app {
    font-family: 'Stag Sans';
    box-sizing: border-box;

    * {
    font-family: 'Stag Sans';
    box-sizing: border-box;
    }
  
    h1, .h1 {
      line-height: 1;
      font-weight: 700;
      font-size: 1.875rem;
      color: var(--color-sleepunique-light-red);

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        font-size: 2.75rem;
      }
    }

    h2, .h2 {
      line-height: 1;
      font-weight: 700;
      font-size: 1.875rem;
      color: var(--color-sleepunique-light-red);

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        font-size: 2rem;
      }
    }

    h3, .h3 {
      line-height: 1;
      font-weight: 700;
      font-size: 1.5625rem;
      color: var(--color-base-white);

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        font-size: 1.5rem;
      }
    }

    p {
      font-size: 0.875rem;
      line-height: 1.285;
      font-weight: 300;
      color: var(--color-base-white);

      ${({ theme }) => theme.breakpoints.minBp('tablet')} {
        font-size: 1.25rem;
        line-height: 1.5;
      }
    }

    strong {
      font-size: 1rem;
      font-weight: 500;
    }

    .error {
      font-weight: 300;
      font-size: 0.875rem;
      color: var(--color-error-warning);
    }
  }
`;
